import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {VideoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export function GalleryVideoIcon(props: ComponentProps<"div">) {
    const {className, ...rest} = props;

    return (
        <div className={cx(counterHolder, className)} {...rest}>
            <div className={counterHolderIcon}>
                <VideoIcon size="2.8" fill="var(--colors-secondary)" />
            </div>

            <Text variant="info_txt_3" align="center" noWrap>
                video
            </Text>
        </div>
    );
}

const counterHolder = css({
    borderRadius: 0.5,
    padding: 0.5,
    backgroundColor: "var(--colors-info)",
    pointerEvents: "none",
    minWidth: 48,
    minHeight: 48
});

const counterHolderIcon = css({
    marginBottom: 1,
    marginTop: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {VideoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export function GalleryVideoIcon(props: ComponentProps<"div">) {
    const {className, ...rest} = props;

    return (
        <div className={cx(counterHolder, className)} {...rest}>
            <div className={counterHolderIcon}>
                <VideoIcon size="2.8" fill="var(--colors-secondary)" />
            </div>

            <Text variant="info_txt_3" align="center" noWrap>
                video
            </Text>
        </div>
    );
}

const counterHolder = css({
    borderRadius: 0.5,
    padding: 0.5,
    backgroundColor: "var(--colors-info)",
    pointerEvents: "none",
    minWidth: 48,
    minHeight: 48
});

const counterHolderIcon = css({
    marginBottom: 1,
    marginTop: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
